import { render, staticRenderFns } from "./PanelAccountInfo.vue?vue&type=template&id=1f6c916c&scoped=true&"
import script from "./PanelAccountInfo.vue?vue&type=script&lang=js&"
export * from "./PanelAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountInfo.vue?vue&type=style&index=0&id=1f6c916c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c916c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
